<app-layout type="blue">
  <div id="mfa">
    <h1>{{ 'login.title' | translate }}</h1>
    <app-icon-title-underline />
    <router-outlet></router-outlet>
  </div>
</app-layout>
